if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.popup = this.querySelector('[data-product-popup]');
      this.popup
        ?.querySelector('[data-close-button]')
        .addEventListener('click', this.closePopup.bind(this));
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.onSubmitHandler(event);
      });
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
    }

    closePopup() {
      this.popup.style.maxHeight = '';
    }
    showPopup() {
      this.popup.style.maxHeight = '100vh';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const sectionsToFetch = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id),
      ];

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          // Check if there are errors in the response
          if (parsedState.description && parsedState.status == 422) {
            throw new Error(parsedState.description);
          }

          // Tell the user that something is wrong when there are no sections returned in the response.
          if (!parsedState.sections) {
            throw new Error(window.cartStrings.error);
          }

          // Check if whe have the cart drawer to update
          if (!this.cartDrawer || 'sections' in parsedState == false) return;

          this.cartDrawer.renderContents(parsedState);

          switch (submitButton.dataset.addToCartBehavior) {
            case 'open_cart_drawer':
              if (this.cartDrawer) this.cartDrawer.open();
              break;
            case 'show_cart_notification':
            default:
              this.cartNotification.setActiveElement(document.activeElement);
              this.cartNotification.renderContents(parsedState);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.formToggleButton = this.querySelector('[data-form-toggle]');
    this.backdropToggle = this.querySelector('[data-form-backdrop]');
    this.submitButton = this.querySelector('[type="submit"]');

    // Bind toggle event
    if (this.formToggleButton) {
      this.formToggleButton.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.innerWidth > 767) return;
        if (window.innerWidth < 768) {
          const productVariants = document.querySelector('[data-product-variants]');
          const backdrop = document.querySelector('[data-form-backdrop]');

          this.classList.toggle('visibility-hidden');
          backdrop.classList.toggle('visibility-hidden');

          //Clone .product-form__variants-wrapper and insert it into the product-form element
          const productForm = document.querySelector('product-form');
          const clonedProductVariants = document.querySelector('.product-variant__content-size');
          const productVariantsClone = clonedProductVariants.cloneNode(true);

          //move the productVariantsClone to just before the submit button
          productForm.insertBefore(
            productVariantsClone,
            productForm.children[productForm.children.length - 1]
          );

          //add an event to this cloned element, on click, get the index of the child and console log it
          clonedProductVariants.addEventListener('click', function (e) {
            const index = Array.from(clonedProductVariants.children).indexOf(e.target);
          });
        }
      });
    }
    if (this.backdropToggle) {
      this.backdropToggle.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.innerWidth > 767) return;
        if (window.innerWidth < 768) {
          const productVariants = document.querySelector('[data-product-variants]');
          const toggleButton = document.querySelector('[data-form-toggle]');

          this.classList.toggle('visibility-hidden');

          //if there is no ?variant= in the url, toggle the visibility of the toggleButton
          if (!window.location.search.includes('variant=')) {
            toggleButton.classList.toggle('visibility-hidden');
          }
          //destroy the cloned element in the product-form
          document.querySelector('sticky-add-to-cart .product-variant__content-size').remove();
        }
      });
    }
  }
}
/**
 * handleQuantityInput
 * @description Toggle the product form on the sticky add to cart (mobile)
 */

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
